// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3pE7_","left":"styles_left__2gI45"};